export const CDE_REVIEW_COLUMNS = [
  {
    dataIndex: "critical_data_element_value",
    key: "critical_data_element_value",
    title: "Critical Data Element Value",
    sorter: true,
  },
  {
    dataIndex: "occurrences",
    key: "occurrences",
    title: "Occurrences",
    sorter: true,
  },
];

export const TEMPORARY_CDE_REVIEW_REPORT_DATA = [
  {
    critical_data_element_value: "abcdef ghijklcecer",
    occurrences: 23,
  },
  {
    critical_data_element_value: "abcdef ghijklcecer",
    occurrences: 23,
  },
  {
    critical_data_element_value: "abcdef ghijklcecer",
    occurrences: 23,
  },
  {
    critical_data_element_value: "abcdef ghijklcecer",
    occurrences: 23,
  },
  {
    critical_data_element_value: "abcdef ghijklcecer",
    occurrences: 23,
  },
  {
    critical_data_element_value: "abcdef ghijklcecer",
    occurrences: 23,
  },
  {
    critical_data_element_value: "abcdef ghijklcecer",
    occurrences: 23,
  },
  {
    critical_data_element_value: "abcdef ghijklcecer",
    occurrences: 23,
  },
  {
    critical_data_element_value: "abcdef ghijklcecer",
    occurrences: 23,
  },
  {
    critical_data_element_value: "abcdef ghijklcecer",
    occurrences: 23,
  },
  {
    critical_data_element_value: "abcdef ghijklcecer",
    occurrences: 23,
  },
  {
    critical_data_element_value: "abcdef ghijklcecer",
    occurrences: 23,
  },
  {
    critical_data_element_value: "abcdef ghijklcecer",
    occurrences: 23,
  },
  {
    critical_data_element_value: "abcdef ghijklcecer",
    occurrences: 23,
  },
  {
    critical_data_element_value: "abcdef ghijklcecer",
    occurrences: 23,
  },
  {
    critical_data_element_value: "abcdef ghijklcecer",
    occurrences: 23,
  },
  {
    critical_data_element_value: "abcdef ghijklcecer",
    occurrences: 23,
  },
  {
    critical_data_element_value: "abcdef ghijklcecer",
    occurrences: 23,
  },
  {
    critical_data_element_value: "abcdef ghijklcecer",
    occurrences: 23,
  },
  {
    critical_data_element_value: "abcdef ghijklcecer",
    occurrences: 23,
  },
  {
    critical_data_element_value: "abcdef ghijklcecer",
    occurrences: 23,
  },
  {
    critical_data_element_value: "abcdef ghijklcecer",
    occurrences: 23,
  },
  {
    critical_data_element_value: "abcdef ghijklcecer",
    occurrences: 23,
  },
  {
    critical_data_element_value: "abcdef ghijklcecer",
    occurrences: 23,
  },
  {
    critical_data_element_value: "abcdef ghijklcecer",
    occurrences: 23,
  },
  {
    critical_data_element_value: "abcdef ghijklcecer",
    occurrences: 23,
  },
  {
    critical_data_element_value: "abcdef ghijklcecer",
    occurrences: 23,
  },
  {
    critical_data_element_value: "abcdef ghijklcecer",
    occurrences: 23,
  },
  {
    critical_data_element_value: "abcdef ghijklcecer",
    occurrences: 23,
  },
  {
    critical_data_element_value: "abcdef ghijklcecer",
    occurrences: 23,
  },
  {
    critical_data_element_value: "abcdef ghijklcecer",
    occurrences: 23,
  },
  {
    critical_data_element_value: "abcdef ghijklcecer",
    occurrences: 23,
  },
];

export const TABLE_PAGE_SIZE = 15;
